import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { DisputeService } from '../../services/dispute.service';
import { JobsService } from '../../services/job.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'new-dispute',
  templateUrl: './new-dispute.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class NewDisputeComponent implements OnInit {
  public isShowCreateDispute: boolean = false;
  public isBusySubmit: boolean = false;
  public isBusyLoadJob: boolean = false;
  public isBusyLoadUser: boolean = false;
  public isBusyLoadTypes: boolean = false;

  public jobNumberError: boolean = false;
  public loadUserError: boolean = false;
  public loadTypesError: boolean = false;

  public currentUser: any = null;
  public orderId?: number;

  public get currentTime(): Date {
    return new Date();
  }

  public jobNumber: string = '';
  public disputeMessage: string = '';

  public jobId: number = 0;

  public types: any[] = [];
  public selectedType: any = null;

  public orders: any[] = [];
  public selectedOrder: any = null;

  @Output() disputeCreated: EventEmitter<any>;

  constructor(
    private jobsService: JobsService,
    private userService: UserService,
    public messageService: MessageService,
    private disputeService: DisputeService,
  ) {
    this.disputeCreated = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.isBusyLoadUser = true;
    this.userService
      .getLoggedUser()
      .then((result) => {
        this.isBusyLoadUser = false;
        if (result != null) {
          this.currentUser = result;
        } else {
          this.loadUserError = true;
          this.messageService.add(
            Message.Error(
              "An error occurred while loading the current user's data.",
              'Create Dispute',
            ),
          );
        }
      })
      .catch((ex) => {
        this.isBusyLoadUser = false;
        this.loadUserError = true;
        this.messageService.add(
          Message.Error(
            "An error occurred while loading the current user's data.",
            'Create Dispute',
          ),
        );
      });

    this.isBusyLoadTypes = true;
    this.disputeService
      .getTypes()
      .then((x) => {
        this.isBusyLoadTypes = false;
        this.types.push({ label: 'Please Select', value: null });
        x.forEach((x) => {
          this.types.push({ label: x.name, value: x });
        });
      })
      .catch((ex) => {
        this.isBusyLoadTypes = false;
        this.loadTypesError = true;
        this.messageService.add(
          Message.Error(
            "An error occurred while loading the current user's data.",
            'Create Dispute',
          ),
        );
      });
  }

  createNewDispute(jobId: number, orderList: any[], orderId?: number) {
    this.isShowCreateDispute = true;
    this.isBusyLoadJob = true;
    this.disputeMessage = '';
    this.selectedType = null;
    this.jobNumberError = false;
    this.orderId = orderId;

    this.selectedOrder = null;
    this.orders = [];
    this.orders.push({ label: 'Please Select', value: null });
    orderList.forEach((x) => {
      this.orders.push({ label: x.name, value: x });
    });

    if (orderId != null) this.selectedOrder = orderList.find((x) => x.id == orderId);

    this.jobsService
      .getJobNumber(jobId)
      .then((result) => {
        this.isBusyLoadJob = false;
        if (result != null && result != '') {
          this.jobId = jobId;
          this.jobNumber = result;
          this.jobNumberError = false;
        } else {
          this.jobNumberError = true;
          this.messageService.add(
            Message.Error('An error occurred while loading job information.', 'Create Dispute'),
          );
        }
      })
      .catch((x) => {
        this.isBusyLoadJob = false;
        this.jobNumberError = true;
        this.messageService.add(
          Message.Error('An error occurred while loading job information.', 'Create Dispute'),
        );
      });
  }

  close() {
    this.isShowCreateDispute = false;
  }

  submit() {
    this.isBusySubmit = true;
    this.disputeService
      .createDispute({
        jobId: this.jobId,
        orderId: this.selectedOrder ? this.selectedOrder.id : null,
        message: this.disputeMessage,
        createDateTime: this.currentTime,
        type: this.selectedType.id,
      })
      .then((result) => {
        this.isBusySubmit = false;
        this.isShowCreateDispute = false;
        this.disputeCreated.emit();
      })
      .catch((ex) => {
        this.isBusySubmit = false;
        this.messageService.add(
          Message.Error(
            'An error occurred while saving the dispute. Please try again or contact your administrator.',
            'Create Dispute',
          ),
        );
      });
  }
}
